import {object_get} from 'kickstart-ui/lib/objects';

/**
 *
 * @param state
 * @return {Function}
 */
export function getFilter(state) {
    return (namespace, where) => {
        if ( state.filters[namespace] ) {
            return object_get(state.filters[namespace], where);
        }
    };
}

/**
 *
 * @param state
 * @returns {function(string): boolean}
 */
export function namespaceIsFiltered(state) {
    return (namespace) => namespace in state.filters
        ? Object.keys(state.filters[namespace]).length > 0
        : false;
}

/**
 *
 * @param state
 * @return {function(*=)}
 */
export function filters(state) {
    return state.filters;
}

/**
 * @param state
 * @returns {*}
 */
export function dependent_filters(state) {
    return state.dependent_filters;
}
